// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/button.scss';
import React from 'react';
import { ButtonTypeClass } from './ButtonType';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { Size } from '@front/sharedcomponents/Variables';
export const Button = (_a) => {
    var { type, text, size = Size.Medium, disabled = false, icon = null, onClick } = _a, restProps = __rest(_a, ["type", "text", "size", "disabled", "icon", "onClick"]);
    const buttonClasses = ['button', size, ButtonTypeClass[type]];
    const buttonClass = buttonClasses.filter(Boolean).join(' ');
    return (React.createElement("button", Object.assign({ className: buttonClass, onClick: onClick, disabled: disabled }, restProps),
        React.createElement(SvgIcon, { icon: icon, size: size }),
        React.createElement("span", { className: "button-text" }, text)));
};
